import { createFileRoute } from '@tanstack/react-router';
import { requireFeature } from '@/common/utils/requireFeature';
import { TicketDetailView } from '@/features/tech-systems/components/TicketDetailView';
import { PermissionGate } from '@/components/PermissionGate';
import { Permission } from '@/common/enums/permissions.enum';

export const Route = createFileRoute(
  '/_authenticated/tech-systems/tickets/$ticketId',
)({
  beforeLoad: () => requireFeature('TECH_SYSTEMS'),
  component: TechSystemTicketDetailPage,
});

function TechSystemTicketDetailPage() {
  const { ticketId } = Route.useParams();

  return (
    <PermissionGate permission={Permission.TECH_SYSTEMS_VIEW}>
      <TicketDetailView
        ticketId={ticketId}
        backTo="/tech-systems/tickets"
        backLabel="Voltar para tickets"
      />
    </PermissionGate>
  );
}
